import { render, staticRenderFns } from "./BlockFeaturedVideoSection.vue?vue&type=template&id=7294e43b&scoped=true&"
import script from "./BlockFeaturedVideoSection.vue?vue&type=script&lang=js&"
export * from "./BlockFeaturedVideoSection.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeaturedVideoSection.vue?vue&type=style&index=0&id=7294e43b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294e43b",
  null
  
)

export default component.exports